import { useCallback, useEffect } from "react";
import { useState } from "react";

const useDevice = () => {
  const [value, setValue] = useState({
    isMobile: false,
    isTablet: false,
    isDesktop: false,
    device: ["mobile", "desktop", "tablet"],
  });

  const handleResize = useCallback(() => {
    if (window.innerWidth < 1024) {
      setValue({
        isTablet: true,
        isMobile: true,
        isDesktop: false,
      });
    } else if (window.innerWidth < 1280) {
      setValue({
        isDesktop: false,
        isMobile: false,
        isTablet: true,
      });
    } else {
      setValue({
        isDesktop: true,
        isMobile: false,
        isTablet: false,
      });
    }
  }, []);

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return value;
};
export default useDevice;
